import React from "react";
import TableCell from "../../common/ui/TableCell";
import ScarResultEditor from "../editor/ChecklistResultSection";

const progressColor = (s) => {
  const v = String(s || "")
    .trim()
    .toLowerCase();
  if (["planned"].includes(v)) return "text-blue-600"; // 점검 예정
  if (["in_progress", "processing"].includes(v)) return "text-amber-600"; // 조치 중
  if (["completed", "complete"].includes(v)) return "text-emerald-600"; // 조치 완료
  if (["cancelled", "canceled"].includes(v)) return "text-gray-500"; // 취소
  if (["fail", "urgent", "emergency"].includes(v)) return "text-rose-600"; // 부적합 / 긴급
  return "text-gray-600";
};

const progressLabel = (s) => {
  const v = String(s || "")
    .trim()
    .toLowerCase();
  switch (v) {
    case "planned":
      return "점검 예정";
    case "completed":
    case "complete":
      return "조치 완료";
    case "in_progress":
    case "processing":
      return "조치 중";
    case "cancelled":
    case "canceled":
      return "취소";
    case "urgent":
    case "emergency":
      return "긴급";
    case "fail":
      return "부적합";
    default:
      return s || "-";
  }
};

export default function ChecklistView({ doc, attachment }) {
  const meta = doc?.meta || {};

  // ✅ check / scar 만 존재
  const docType =
    meta.doc_type?.toLowerCase?.() || doc?.doc_type?.toLowerCase?.() || "check";

  // ─── 기본 필드 ───
  const checkType = meta.check_type || "-";
  const checkDate = meta.check_date || "-";
  const overallResult = meta.overall_result || "-";
  const memo = meta.memo || "-";
  const progress = meta.progress || "planned";
  const inspector = meta.inspector || "-";
  const confirmer = meta.confirmer || "-";

  // ─── 점검 항목 / SCAR / 사진 ───
  const items = Array.isArray(meta.items) ? meta.items : [];
  const photos = Array.isArray(meta.photos) ? meta.photos : [];

  // ✅ ChecklistEditor의 필드명 기준
  const scarProblem = meta.scarProblem || meta.scar_problem || "";
  const scarImmediate = meta.scarImmediate || meta.scar_immediate || "";
  const scarRootCause = meta.scarRootCause || meta.scar_root_cause || "";
  const scarActions =
    Array.isArray(meta.scarActions) || Array.isArray(meta.scar_actions)
      ? meta.scarActions || meta.scar_actions
      : [];

  // ✅ 결과 상태 관련 meta 반영
  const resultStatus = meta.result_status || "-";
  const failReason = meta.fail_reason || "-";
  const failOwner = meta.fail_owner || "-";

  const section = "rounded-2xl border bg-white p-4";
  const sectionStyle = {
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
  };

  // ─────────────────────────────
  return (
    <div className="w-full space-y-6 text-sm text-gray-800">
      {/* ───────────── 기본 정보 ───────────── */}
      <table className="min-w-full text-sm border">
        <tbody>
          {/* <tr>
            <TableCell
                label="문서 유형"
                value={docType === "check" ? "점검 예정" : "SCAR 보고"}
              />
            <TableCell label="점검 구분" value={checkType} />
          </tr> */}
          <tr>
            <TableCell
              label="점검 상태"
              value={
                <span className={`font-medium ${progressColor(progress)}`}>
                  {progressLabel(progress)}
                </span>
              }
            />
            <TableCell
              label={docType === "scar" ? "조치일" : "점검 예정일"}
              value={checkDate}
            />
          </tr>
          <tr>
            <TableCell label="점검자" value={inspector} />
            <TableCell label="확인자" value={confirmer} />
          </tr>
          {/* <tr>
            <TableCell label="전체 결과" colSpan={3} value={overallResult} />
          </tr>
          <tr>
            <TableCell
              label="결과 상태"
              colSpan={3}
              value={resultStatus || "-"}
            />
          </tr> */}
          <tr>
            <TableCell label="점검 사항" colSpan={3} value={memo || "-"} />
          </tr>

          {/* 부적합일 때만 표시 */}
          {String(resultStatus).toLowerCase() === "failed" && (
            <>
              <tr>
                <TableCell label="부적합 사유" value={failReason} />
                <TableCell label="담당자" value={failOwner} />
              </tr>
            </>
          )}
        </tbody>
      </table>

      {/* ───────────── 점검 항목 (check용) ─────────────
      {docType === "check" && (
        <>
          <div className="text-sm font-semibold">점검 결과 항목</div>
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm border">
              <thead className="bg-gray-50 text-gray-600">
                <tr>
                  <th className="px-2 py-2 w-[16%] text-left">분류</th>
                  <th className="px-2 py-2 w-[28%] text-left">항목</th>
                  <th className="px-2 py-2 w-[28%] text-left">점검 기준</th>
                  <th className="px-2 py-2 w-[12%] text-left">결과</th>
                  <th className="px-2 py-2 w-[16%] text-left">비고</th>
                </tr>
              </thead>
              <tbody>
                {items.length === 0 ? (
                  <tr>
                    <td colSpan={5} className="text-center text-gray-500 py-3">
                      등록된 점검 항목이 없습니다.
                    </td>
                  </tr>
                ) : (
                  items.map((r, i) => (
                    <tr key={i} className="border-t">
                      <td className="px-2 py-1">{r.category || "-"}</td>
                      <td className="px-2 py-1">{r.item || "-"}</td>
                      <td className="px-2 py-1">{r.criteria || "-"}</td>
                      <td className="px-2 py-1">{r.result || "-"}</td>
                      <td className="px-2 py-1">{r.remark || "-"}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </>
      )} */}

      {/* ───────────── SCAR 항목 ───────────── */}
      {docType === "scar" && (
        <section className={section} style={sectionStyle}>
          <div
            className="text-xs font-semibold mb-2"
            style={{ fontSize: "0.75rem", lineHeight: "1rem" }}
          >
            SCAR 보고서
          </div>
          <div
            className="space-y-2 min-w-0"
            style={{ width: "100%", maxWidth: "100%", boxSizing: "border-box" }}
          >
            <div
              className="flex items-start gap-2 min-w-0"
              style={{
                width: "100%",
                maxWidth: "100%",
                boxSizing: "border-box",
              }}
            >
              <div
                className="w-20 flex-shrink-0 text-xs text-gray-600 font-medium"
                style={{ fontSize: "0.75rem" }}
              >
                문제 정의
              </div>
              <div
                className="flex-1 min-w-0 text-xs text-gray-900 break-words"
                style={{ fontSize: "0.75rem", wordBreak: "break-word" }}
              >
                {scarProblem || "-"}
              </div>
            </div>
            <div
              className="flex items-start gap-2 min-w-0"
              style={{
                width: "100%",
                maxWidth: "100%",
                boxSizing: "border-box",
              }}
            >
              <div
                className="w-20 flex-shrink-0 text-xs text-gray-600 font-medium"
                style={{ fontSize: "0.75rem" }}
              >
                즉시 조치
              </div>
              <div
                className="flex-1 min-w-0 text-xs text-gray-900 break-words"
                style={{ fontSize: "0.75rem", wordBreak: "break-word" }}
              >
                {scarImmediate || "-"}
              </div>
            </div>
            <div
              className="flex items-start gap-2 min-w-0"
              style={{
                width: "100%",
                maxWidth: "100%",
                boxSizing: "border-box",
              }}
            >
              <div
                className="w-20 flex-shrink-0 text-xs text-gray-600 font-medium"
                style={{ fontSize: "0.75rem" }}
              >
                근본 원인
              </div>
              <div
                className="flex-1 min-w-0 text-xs text-gray-900 break-words"
                style={{ fontSize: "0.75rem", wordBreak: "break-word" }}
              >
                {scarRootCause || "-"}
              </div>
            </div>
          </div>

          {scarActions.length > 0 && (
            <div
              className="mt-3 min-w-0"
              style={{
                width: "100%",
                maxWidth: "100%",
                boxSizing: "border-box",
              }}
            >
              <div
                className="text-xs font-medium mb-2"
                style={{ fontSize: "0.75rem", lineHeight: "1rem" }}
              >
                시정조치 계획
              </div>
              <div
                className="space-y-2 min-w-0"
                style={{
                  width: "100%",
                  maxWidth: "100%",
                  boxSizing: "border-box",
                }}
              >
                {scarActions.map((a, idx) => (
                  <div
                    key={idx}
                    className="border rounded-lg p-2 bg-gray-50 min-w-0"
                    style={{
                      width: "100%",
                      maxWidth: "100%",
                      boxSizing: "border-box",
                    }}
                  >
                    <div
                      className="space-y-1.5 min-w-0"
                      style={{
                        width: "100%",
                        maxWidth: "100%",
                        boxSizing: "border-box",
                      }}
                    >
                      <div
                        className="flex items-start gap-2 min-w-0"
                        style={{
                          width: "100%",
                          maxWidth: "100%",
                          boxSizing: "border-box",
                        }}
                      >
                        <div
                          className="w-20 flex-shrink-0 text-xs text-gray-600 font-medium"
                          style={{ fontSize: "0.75rem" }}
                        >
                          조치 내용
                        </div>
                        <div
                          className="flex-1 min-w-0 text-xs text-gray-900 break-words"
                          style={{
                            fontSize: "0.75rem",
                            wordBreak: "break-word",
                          }}
                        >
                          {a.action || "-"}
                        </div>
                      </div>
                      <div
                        className="flex items-start gap-2 min-w-0"
                        style={{
                          width: "100%",
                          maxWidth: "100%",
                          boxSizing: "border-box",
                        }}
                      >
                        <div
                          className="w-20 flex-shrink-0 text-xs text-gray-600 font-medium"
                          style={{ fontSize: "0.75rem" }}
                        >
                          담당자
                        </div>
                        <div
                          className="flex-1 min-w-0 text-xs text-gray-900 truncate"
                          style={{
                            fontSize: "0.75rem",
                            minWidth: 0,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {a.owner || "-"}
                        </div>
                      </div>
                      <div
                        className="flex items-start gap-2 min-w-0"
                        style={{
                          width: "100%",
                          maxWidth: "100%",
                          boxSizing: "border-box",
                        }}
                      >
                        <div
                          className="w-20 flex-shrink-0 text-xs text-gray-600 font-medium"
                          style={{ fontSize: "0.75rem" }}
                        >
                          목표일
                        </div>
                        <div
                          className="flex-1 min-w-0 text-xs text-gray-900 truncate"
                          style={{
                            fontSize: "0.75rem",
                            minWidth: 0,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {a.due || "-"}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </section>
      )}

      {/* ───────────── 사진 ───────────── */}
      {photos.length > 0 && (
        <section className={section} style={sectionStyle}>
          <div
            className="text-xs font-semibold mb-2"
            style={{ fontSize: "0.75rem", lineHeight: "1rem" }}
          >
            첨부 사진
          </div>
          <div
            className="grid grid-cols-2 gap-2 min-w-0"
            style={{
              width: "100%",
              maxWidth: "100%",
              boxSizing: "border-box",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "0.5rem",
            }}
          >
            {photos.map((p, i) => (
              <div
                key={i}
                className="rounded-lg border bg-gray-50 p-2 flex flex-col items-center min-w-0"
                style={{
                  width: "100%",
                  maxWidth: "100%",
                  boxSizing: "border-box",
                }}
              >
                {p.url ? (
                  <img
                    src={p.url}
                    alt={p.name}
                    className="h-24 w-full object-contain min-w-0"
                    style={{
                      height: "6rem",
                      width: "100%",
                      maxWidth: "100%",
                      boxSizing: "border-box",
                    }}
                  />
                ) : (
                  <span
                    className="text-xs text-gray-400"
                    style={{ fontSize: "0.75rem" }}
                  >
                    이미지 없음
                  </span>
                )}
                <div
                  className="mt-1 text-[10px] text-gray-600 truncate w-full text-center min-w-0"
                  style={{
                    fontSize: "0.625rem",
                    width: "100%",
                    maxWidth: "100%",
                    boxSizing: "border-box",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {p.name || "-"}
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      {docType === "scar" && (
        <ScarResultEditor
          onSubmit={(data) => {
            console.log("회신 등록:", data);
            // TODO: axios.post(`/api/safety/scar-comments/`, { ...data, dns: doc.dns });
          }}
        />
      )}
    </div>
  );
}
